/* ─────────────────────────────────────────────────────────────────────────
   Build a gift — selection state for sections/build-a-gift.liquid.
   - Step A: box size (Pair = 2 / Trio = 3), trimming the selection on change
   - Step B: tile toggling with an index badge; full box → subtle shake
   - Step C: summary slots, total from data-price (cents), one /cart/add.js
     POST for the whole set, then PavosCart.refreshDrawer() + openDrawer()
   ──────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  var NUMBER_WORDS = { 1: 'one', 2: 'two', 3: 'three' };
  var ADD_LABEL = 'Add set to bag';
  var ADDING_LABEL = 'Adding…';

  function formatMoney(cents) {
    var rupees = cents / 100;
    var hasPaise = Math.round(cents) % 100 !== 0;
    try {
      return '₹' + rupees.toLocaleString('en-IN', {
        minimumFractionDigits: hasPaise ? 2 : 0,
        maximumFractionDigits: 2
      });
    } catch (e) {
      return '₹' + (hasPaise ? rupees.toFixed(2) : Math.round(rupees));
    }
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function initSection(root) {
    if (!root || root.hasAttribute('data-gift-ready')) return;
    root.setAttribute('data-gift-ready', '');

    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-gift-tile]'));
    var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-gift-box]'));
    var slotsEl = root.querySelector('[data-slots]');
    var totalEl = root.querySelector('[data-total]');
    var boxNameEl = root.querySelector('[data-box-name]');
    var remainingEl = root.querySelector('[data-remaining]');
    var addBtn = root.querySelector('[data-add-set]');
    var clearBtn = root.querySelector('[data-clear]');
    if (!tiles.length || !slotsEl || !addBtn) return;

    var boxSize = 2;
    var boxName = 'A Pair';
    var selected = []; /* tile elements, in pick order */

    function renderSlots() {
      slotsEl.textContent = '';
      for (var i = 0; i < boxSize; i += 1) {
        var tile = selected[i];
        var li = el('li', 'build-gift__slot');
        if (tile) {
          var main = el('span', 'build-gift__slot-main');
          main.appendChild(el('span', 'build-gift__slot-num serif-italic', String(i + 1)));
          main.appendChild(
            el('span', 'build-gift__slot-title', tile.getAttribute('data-title') || '')
          );
          li.appendChild(main);
          var cents = parseInt(tile.getAttribute('data-price'), 10) || 0;
          li.appendChild(el('span', 'build-gift__slot-price', formatMoney(cents)));
        } else {
          li.classList.add('build-gift__slot--empty');
          li.appendChild(el('span', 'build-gift__slot-num serif-italic', String(i + 1)));
          li.appendChild(el('span', 'build-gift__slot-empty serif-italic', 'Still unchosen.'));
        }
        slotsEl.appendChild(li);
      }
    }

    function render() {
      var full = selected.length >= boxSize;

      tiles.forEach(function (tile) {
        var index = selected.indexOf(tile);
        var isSelected = index !== -1;
        tile.classList.toggle('is-selected', isSelected);
        tile.classList.toggle('is-blocked', full && !isSelected);
        tile.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        var badge = tile.querySelector('[data-slot-badge]');
        if (badge) {
          if (isSelected) {
            badge.textContent = String(index + 1);
            badge.removeAttribute('hidden');
          } else {
            badge.setAttribute('hidden', '');
          }
        }
      });

      boxes.forEach(function (box) {
        var active = parseInt(box.getAttribute('data-box-size'), 10) === boxSize;
        box.classList.toggle('is-active', active);
        box.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (boxNameEl) boxNameEl.textContent = boxName;

      renderSlots();

      var total = selected.reduce(function (sum, tile) {
        return sum + (parseInt(tile.getAttribute('data-price'), 10) || 0);
      }, 0);
      if (totalEl) totalEl.textContent = total > 0 ? formatMoney(total) : '—';

      var remaining = boxSize - selected.length;
      if (remainingEl) {
        if (remaining > 0) {
          remainingEl.textContent =
            'Choose ' + (NUMBER_WORDS[remaining] || remaining) + ' more.';
          remainingEl.removeAttribute('hidden');
        } else {
          remainingEl.setAttribute('hidden', '');
        }
      }

      addBtn.disabled = !full;
      if (clearBtn) {
        if (selected.length > 0) {
          clearBtn.removeAttribute('hidden');
        } else {
          clearBtn.setAttribute('hidden', '');
        }
      }
    }

    boxes.forEach(function (box) {
      box.addEventListener('click', function () {
        boxSize = parseInt(box.getAttribute('data-box-size'), 10) || 2;
        boxName = box.getAttribute('data-box-name') || boxName;
        selected = selected.slice(0, boxSize);
        render();
      });
    });

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        var index = selected.indexOf(tile);
        if (index !== -1) {
          selected.splice(index, 1);
        } else if (selected.length >= boxSize) {
          /* Box is full — ignore, with a subtle shake. */
          tile.classList.remove('is-shake');
          void tile.offsetWidth; /* restart the animation */
          tile.classList.add('is-shake');
          return;
        } else {
          selected.push(tile);
        }
        render();
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        selected = [];
        render();
      });
    }

    addBtn.addEventListener('click', function () {
      if (selected.length !== boxSize) return;

      var items = selected.map(function (tile) {
        return {
          id: parseInt(tile.getAttribute('data-variant-id'), 10),
          quantity: 1
        };
      });

      addBtn.disabled = true;
      addBtn.textContent = ADDING_LABEL;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add-set failed');
          return response.json();
        })
        .then(function () {
          if (window.PavosCart && typeof window.PavosCart.refreshDrawer === 'function') {
            return window.PavosCart.refreshDrawer().then(function () {
              if (typeof window.PavosCart.openDrawer === 'function') {
                window.PavosCart.openDrawer();
              }
            });
          }
          return null;
        })
        .then(function () {
          selected = [];
          addBtn.textContent = ADD_LABEL;
          render();
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = ADD_LABEL;
        });
    });

    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-build-gift]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
